import Text from '@cartwhl/ui/base/Text';

interface BenchmarkRow {
  label: string;
  value: number;
}

interface BenchmarkPreviewProps {
  // The first row is the featured model.
  rows: BenchmarkRow[];
  // Top of the score scale; bars fill relative to this.
  max?: number;
  caption?: string;
}

export default function BenchmarkPreview({
  rows,
  max = Math.max(...rows.map((row) => row.value)),
  caption,
}: BenchmarkPreviewProps) {
  return (
    <figure className="article-breakout my-8 px-4 lg:my-12 lg:px-0">
      <div className="bg-secondary rounded-2xl p-6 lg:p-10">
        <ul className="space-y-4">
          {rows.map((row, index) => (
            <li
              key={row.label}
              className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-4 gap-y-2 lg:grid-cols-[200px_minmax(0,1fr)_48px]"
            >
              <Text
                as="span"
                variant={index === 0 ? 'web/body/medium/md' : 'web/body/md'}
                className={index === 0 ? 'text-primary' : 'text-secondary'}
              >
                {row.label}
              </Text>
              <Text
                as="span"
                variant={index === 0 ? 'web/body/medium/md' : 'web/body/md'}
                className={`text-right tabular-nums lg:order-last ${index === 0 ? 'text-primary' : 'text-secondary'}`}
              >
                {row.value}
              </Text>
              <span className="bg-primary col-span-2 block h-2.5 overflow-hidden rounded-full lg:col-span-1">
                <span
                  className={`block h-full rounded-full ${index === 0 ? 'bg-green-50' : 'bg-gray-45'}`}
                  style={{ width: `${Math.max((row.value / max) * 100, 1)}%` }}
                />
              </span>
            </li>
          ))}
        </ul>
      </div>
      {caption && (
        <figcaption className="article-caption mx-auto mt-3 px-4">
          <Text
            as="span"
            variant="web/body/medium/xs"
            className="text-tertiary"
          >
            {caption}
          </Text>
        </figcaption>
      )}
    </figure>
  );
}
